import React, { Fragment, useState, useEffect } from 'react';
import { Link, useHistory, useParams } from 'react-router-dom';
import { postData, fetchData } from '../../../apiService';
import Select from 'react-select'; // Import react-select
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, IconButton } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import AsyncSelect from 'react-select/async';
import DoneIcon from '@mui/icons-material/Done';
import CloseIcon from '@mui/icons-material/Close';
import CopyrightIcon from '@mui/icons-material/Copyright';
import ReplyAllIcon from '@mui/icons-material/ReplyAll';

const IncomeExpenseDetails = ({ match }) => {
    const [isLoading, setIsLoading] = useState(false);
    const history = useHistory();
    const { id } = useParams();
    const { isAuthenticated, companyId, branchId, userId, permissions, token, logout, branchstate } = useAuth();
    const [supplierOptions, setSupplierOptions] = useState([]);
    const [selectedOption, setSelectedOption] = useState(null);

    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }
    }, [isAuthenticated, companyId, token, logout]);

    const [selectedPaymentType, setSelectedPaymentType] = useState("1");
    const [paymentmethodOptions, setPaymentmethodOptions] = useState([]);
    const [selectedPaymentmethodType, setSelectedPaymentmethodType] = useState("");
    const parseAndFix = (val) => parseFloat(val) || 0;

    useEffect(() => {
        fetchData('IncomeExpenseApi', `/PaymentData/${id}`, token)
            .then((response) => {
                if (response.responseCode === '1111') {
                    const invoiceData = response.response_data;
                    setFormData({
                        ...invoiceData,
                        UpdatedBy: userId,
                    });
                    console.log(response);
                }
            })
            .catch((error) => {
                console.error('Error fetching Invoice Details:', error);
            })
            .finally(() => {
            });
    }, [id]);

    const [showBankField, setShowBankField] = useState(true);
    const [successMessage, setSuccessMessage] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const [errorMessageModel, setErrorMessageModel] = useState('');

    const [formData, setFormData] = useState({
    });

    // Add a function to format the date
    const formatDateForInput = (dateString) => {
        const currentDate = new Date(dateString);;
        const year = currentDate.getFullYear();
        const month = String(currentDate.getMonth() + 1).padStart(2, '0');
        const day = String(currentDate.getDate()).padStart(2, '0');
        const formattedDate = `${year}-${month}-${day}`;
        return formattedDate;
    };

    useEffect(() => {
        fetchData('IncomeExpenseApi', `/${id}`, token)
            .then((response) => {
                //setLoading(true);
                if (response.responseCode === '1111') {
                    const invoiceData = response.response_data;
                    setFormData({
                        ...invoiceData,
                        UpdatedBy: userId,
                    });
                    console.log(response);
                }
            })
            .catch((error) => {
                console.error('Error fetching Invoice Details:', error);
            })
            .finally(() => {
                //setLoading(false);
            });
    }, [id]);

    return (
        <Fragment>
            <div className="w-full max-w-sm container mt-6 mx-auto" style={{ minWidth: '101%', marginTop: '-0.55%' }}>

                <div className="flex flex-wrap justify-between items-center mb-4">
                    <h6
                        className="uppercase tracking-wide text-black font-serif flex-grow"
                        style={{
                            fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif',
                            color: 'black',
                            marginTop: '-10px',
                        }}
                    >
                        DETAILS INCOME & Expense
                    </h6>
                    <div className="flex items-center w-full sm:w-auto sm:ml-4" style={{ marginRight: '120px', marginTop: '20px' }}>
                        <div className='w-full mb-2 flex'>
                            <label className="block tracking-wide text-gray-700 font-bold" style={{ color: 'darkblue' }}>
                                <input
                                    type="radio"
                                    name="IsType"
                                    value="1"
                                    checked={formData.IsType === true}
                                    disabled
                                />
                                <span style={{ marginLeft: '5px', fontSize: '12px' }}>Income</span>
                            </label>
                            <label className="block tracking-wide text-gray-700 font-bold ml-2" style={{ color: 'brown' }}>
                                <input
                                    type="radio"
                                    name="IsType"
                                    value="0"
                                    checked={formData.IsType === false}
                                    disabled
                                />
                                <span style={{ marginLeft: '5px', fontSize: '12px' }}>Expense</span>
                            </label>
                        </div>
                    </div>

                    <div className="flex mt-8 w-full sm:w-auto" style={{ marginTop: '10px' }}>
                        <Button
                            variant="contained"
                            color="error"
                            component={Link}
                            to={{
                                pathname: "/IncomeExpenseIndex",
                                state: { from: "/IncomeExpenseDetails" },
                            }}
                            onClick={() => {
                                localStorage.setItem("shouldReload", "true");
                            }}
                            style={{ height: "25px", borderRadius: "10px", marginRight: "5px", marginLeft: '5px' }}
                        >
                            Back To List
                        </Button>
                    </div>

                </div>
            </div>

            {errorMessage && <p className="text-red-500">{errorMessage}</p>}
            {successMessage && <p className="text-green-500">{successMessage}</p>}

            <div className="watermark">
                <CopyrightIcon /><b style={{ fontFamily: 'Script Bold Italic' }}>EFFTABS SOLUTIONS LLP</b>
            </div>

            <div className="w-full flex flex-wrap md:flex-row flex-col">
                {/* Left Section: Entry Fields */}
                <div
                    className="flex-1 p-4"
                    style={{
                        backgroundColor: '#f3f3f3',
                        borderRadius: '10px',
                        marginTop: '-10px',
                    }}
                >
                    <div className="mb-3">
                        {/* Row 1: Account Head, Date, Bill Number, GST%, Amount */}
                        <div className="w-full mb-3 flex gap-2">
                            <div className="flex-1">
                                <label className="block uppercase tracking-wide text-black text-xs mb-1" htmlFor="customer">
                                    Account Head <span className="text-red-500">*</span>
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full px-2 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={formData.MasterName}
                                    type="text"
                                    placeholder="CustomerName"
                                    name='CustomerName'
                                    readOnly
                                    style={{ height: '32px', fontSize: '13px' }}
                                />
                            </div>
                            <div style={{ width: '140px' }}>
                                <label className="block uppercase tracking-wide text-black text-xs mb-1" htmlFor="billDate">
                                    Date <span className="text-red-500">*</span>
                                </label>
                                <input
                                    className="shadow border rounded w-full px-2 text-gray-700 leading-tight focus:shadow-outline"
                                    type="date"
                                    value={formatDateForInput(formData.BillDate)}
                                    name="BillDate"
                                    readOnly
                                    style={{ height: '32px', fontSize: '13px' }}
                                />
                            </div>
                            <div style={{ width: '150px' }}>
                                <label className="block uppercase tracking-wide text-black text-xs mb-1" htmlFor="billNumber">
                                    Bill Number <span className="text-red-500">*</span>
                                </label>
                                <input
                                    className="shadow border rounded w-full px-2 text-gray-700 leading-tight focus:shadow-outline"
                                    type="text"
                                    value={`${formData.BillNo || ''}/${formData.FinYear || ''}`}
                                    name="BillNo"
                                    readOnly
                                    style={{ height: '32px', fontSize: '13px' }}
                                />
                            </div>

                            <div style={{ width: '140px' }}>
                                <label
                                    className="block uppercase tracking-wide text-black text-xs mb-1 flex items-center gap-x-2"
                                    htmlFor="gstPercentage"
                                >
                                    GST %
                                    <input
                                        type="checkbox"
                                        className="form-checkbox h-3 w-3 text-red-700"
                                        name="IsIGST"
                                        checked={formData.IsIGST || false}
                                        style={{ marginLeft: '5px' }}
                                        disabled
                                    />
                                    <span className="text-xs text-red-700" style={{ marginLeft: '2px' }}>IGST</span>
                                </label>
                                <select
                                    className="shadow border rounded w-full px-2 text-black-700 leading-tight focus:shadow-outline"
                                    name="GSTRate"
                                    value={formData.GSTRate || 0}
                                    disabled
                                    style={{ height: '32px', fontSize: '13px' }}
                                >
                                    <option value={0}>0</option>
                                    <option value={3}>3</option>
                                    <option value={5}>5</option>
                                    <option value={12}>12</option>
                                    <option value={18}>18</option>
                                    <option value={28}>28</option>
                                </select>
                            </div>

                            <div style={{ width: '140px' }}>
                                <label className="block uppercase tracking-wide text-black text-xs mb-1" htmlFor="amount">
                                    Amount
                                </label>
                                <input
                                    className="shadow border rounded w-full px-2 text-gray-700 leading-tight focus:shadow-outline text-right"
                                    type="number"
                                    value={formData.Amount}
                                    name="Amount"
                                    disabled
                                    style={{ height: '32px', fontSize: '13px' }}
                                />
                            </div>
                        </div>

                        {/* Row 2: GST Summary */}
                        <div className="flex items-center justify-between mb-3" style={{
                            backgroundColor: '#ffffff',
                            padding: '8px 16px',
                            borderRadius: '6px',
                            border: '1px solid #e0e0e0',
                            width: '100%'
                        }}>
                            <div className="flex items-center gap-x-2">
                                <span className="text-xs font-semibold text-gray-700">CGST:</span>
                                <span style={{ color: '#dc2626', fontSize: '14px', fontWeight: '700' }}>
                                    ₹{formData.CGSTAmount || '0.00'}
                                </span>
                            </div>

                            <div className="flex items-center gap-x-2">
                                <span className="text-xs font-semibold text-gray-700">SGST:</span>
                                <span style={{ color: '#dc2626', fontSize: '14px', fontWeight: '700' }}>
                                    ₹{formData.SGSTAmount || '0.00'}
                                </span>
                            </div>

                            <div className="flex items-center gap-x-2">
                                <span className="text-xs font-semibold text-gray-700">IGST:</span>
                                <span style={{ color: '#dc2626', fontSize: '14px', fontWeight: '700' }}>
                                    ₹{formData.IGSTAmount || '0.00'}
                                </span>
                            </div>

                            <div className="flex items-center gap-x-3" style={{
                                paddingLeft: '24px',
                                paddingRight: '8px',
                                borderLeft: '2px solid #e0e0e0',
                                backgroundColor: '#f0fdf4',
                                padding: '6px 20px',
                                borderRadius: '4px'
                            }}>
                                <span className="text-sm font-bold text-gray-800">TOTAL:</span>
                                <span style={{ color: '#059669', fontSize: '16px', fontWeight: '800' }}>
                                    ₹{formData.TotalAmount || '0.00'}
                                </span>
                            </div>
                        </div>

                        {/* Row 3: Remarks - Full Width */}
                        <div className="w-full mb-3">
                            <label className="block uppercase tracking-wide text-black text-xs mb-1" htmlFor="remarks">
                                Remarks
                            </label>
                            <input
                                className="shadow border rounded w-full px-2 text-gray-700 leading-tight focus:shadow-outline"
                                type="text"
                                value={formData.Remarks}
                                name="Remarks"                                
                                style={{ height: '32px', fontSize: '13px' }}
                            />
                        </div>

                        {/* Row 4: Payment Details */}
                        <div className="w-full mb-2 flex gap-2">
                            <div style={{ width: '180px' }}>
                                <label className="block uppercase tracking-wide text-black text-xs mb-1" htmlFor="supplierName">
                                    Payment Mode
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full px-2 text-black-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={(formData.PaymentName)}
                                    name='ReferenceDate'
                                    readOnly
                                    style={{ height: '32px', fontSize: '13px', color: 'darkred', fontWeight: 'bold' }}
                                />
                            </div>
                            <div style={{ width: '180px' }}>
                                <label className="block uppercase tracking-wide text-black text-xs mb-1" htmlFor="billNumber">
                                    {selectedPaymentmethodType && selectedPaymentmethodType.value === 3 ? 'Cheque Bank' : 'Bank'}
                                    <span className="text-red-500">*</span>
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full px-2 text-black-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={(formData.BankName)}
                                    name='ReferenceDate'
                                    readOnly
                                    style={{ height: '32px', fontSize: '13px', color: 'darkred', fontWeight: 'bold' }}
                                />
                            </div>

                            <div className="flex-1">
                                <label className="block uppercase tracking-wide text-black text-xs mb-1" htmlFor="billNumber">
                                    {selectedPaymentmethodType && selectedPaymentmethodType.value === 3 ? 'Cheque No' : 'Reference No'}
                                    <span className="text-red-500">*</span>
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full px-2 text-black-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={formData.ChequeNumber}
                                    type="text"
                                    placeholder=""
                                    name="ChequeNumber"
                                    style={{ height: '32px', fontSize: '13px' }}
                                    disabled={showBankField || (selectedPaymentmethodType && selectedPaymentmethodType.value === '1')}
                                />
                            </div>

                            <div style={{ width: '140px' }}>
                                <label className="block uppercase tracking-wide text-black text-xs mb-1" htmlFor="billNumber">
                                    {selectedPaymentmethodType && selectedPaymentmethodType.value === 3 ? 'Cheque Date' : 'Reference Date'}
                                    <span className="text-red-500">*</span>
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full px-2 text-black-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={formatDateForInput(formData.ChequeDate)}
                                    type="date"
                                    placeholder=""
                                    name="ChequeDate"
                                    style={{ height: '32px', fontSize: '13px' }}
                                    disabled={showBankField || (selectedPaymentmethodType && selectedPaymentmethodType.value === '1')}
                                />
                            </div>

                            <div className="flex-1">
                                <label className="block uppercase tracking-wide text-black text-xs mb-1" htmlFor="billNumber">
                                    {selectedPaymentmethodType && selectedPaymentmethodType.value === 3 ? 'Cheque Details' : 'Reference Details'}
                                    <span className="text-red-500">*</span>
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full px-2 text-black-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={formData.chequeDetails}
                                    type="text"
                                    placeholder=""
                                    name="chequeDetails"
                                    style={{ height: '32px', fontSize: '13px' }}
                                    disabled={showBankField || (selectedPaymentmethodType && selectedPaymentmethodType.value === '1')}
                                />
                            </div>
                        </div>
                    </div>
                </div>

            </div>

        </Fragment >
    );
};


export default IncomeExpenseDetails;
